/* eslint-disable react-refresh/only-export-components */
import ClockIcon from "../../../../../../../assets/svg/clock-icon";
import CompletedIcon from "../../../../../../../assets/svg/completed-icon";
import CrossIcon from "../../../../../../../assets/svg/cross-icon";
import InboxIcon from "../../../../../../../assets/svg/inbox-icon";
import LogsIcon from "../../../../../../../assets/svg/logs-icon";
import MicrosoftTeamsIcon from "../../../../../../../assets/svg/microsoft-teams-icon";
import VerbacallIcon from "../../../../../../../assets/svg/verbacall-icon";
import VerbachatIcon from "../../../../../../../assets/svg/verbachat-icon";
import VerbamailIcon from "../../../../../../../assets/svg/verbamail-icon";
import VerbamessengerIcon from "../../../../../../../assets/svg/verbamessenger-icon";
import ViewingsIcon from "../../../../../../../assets/svg/viewings-icon";
import { AttendeeResponseStatus, ViewingStatus } from "./types";
import VerbasmsIcon from "../../../../../../../assets/svg/verbasms-icon";
import FbMessengerIcon from "../../../../../../../assets/svg/fb-messenger-icon";
import WeChatIcon from "../../../../../../../assets/svg/wechat-icon";
import InstagramIcon from "../../../../../../../assets/svg/instagram-icon";

export const LEAD_DETAILS_LEFT_SUB_PANEL_TABS = [
  {
    id: "communications",
    label: "Communications",
    icon: InboxIcon,
  },
  {
    id: "activityLogs",
    label: "Activity Logs",
    icon: LogsIcon,
  },
  {
    id: "viewings",
    label: "Viewings",
    icon: ViewingsIcon,
    showCount: "viewings",
  },
  {
    id: "callLogs",
    label: "Call Logs",
    icon: VerbacallIcon,
  },
];

export const ViewingStatusColors: Record<
  string,
  { light: { primary: string; secondary: string }; dark: { primary: string; secondary: string } }
> = {
  [ViewingStatus.AWAITING_CONFIRMATION]: {
    light: { primary: "#798699", secondary: "#6674880D" },
    dark: { primary: "#798699", secondary: "#6674880D" },
  },
  [ViewingStatus.COMPLETED]: {
    light: { primary: "#00a32a", secondary: "#00a32a0d" },
    dark: { primary: "#25d366", secondary: "#25d3660d" },
  },
  [ViewingStatus.SCHEDULED]: {
    light: { primary: "#9a78b8", secondary: "#9a78b80d" },
    dark: { primary: "#cc91ff", secondary: "#9a78b80d" },
  },
  [ViewingStatus.NO_SHOW]: {
    light: { primary: "#f76808cc", secondary: "#f768080d" },
    dark: { primary: "#f76808cc", secondary: "#f768080d" },
  },
  [ViewingStatus.CANCELLED]: {
    light: { primary: "#e13f41", secondary: "#e13f410d" },
    dark: { primary: "#f38485", secondary: "#e13f410d" },
  },
};

export const AttendeeResponseBadgeConfig: Record<
  AttendeeResponseStatus,
  { label: string; bgClass: string; textClass: string }
> = {
  accepted: {
    label: "Accepted",
    bgClass: "bg-verba-green-success dark:bg-verba-green-success-dk",
    textClass: "text-fixed-white dark:text-fixed-white-dk",
  },
  declined: {
    label: "Rejected",
    bgClass: "bg-verba-red-alert dark:bg-verba-red-alert-dk",
    textClass: "text-fixed-white dark:text-fixed-white-dk",
  },
  tentative: {
    label: "Tentative",
    bgClass: "bg-dark-yellow-for-alerts dark:bg-dark-yellow-for-alerts-dk",
    textClass: "text-verba-indigo dark:text-verba-indigo-dk",
  },
  maybe: {
    label: "Maybe",
    bgClass: "bg-retrying-status dark:bg-retrying-status-dk",
    textClass: "text-fixed-white dark:text-fixed-white-dk",
  },
};

export const ViewingStatusDropdownOptions = [
  {
    value: "scheduled",
    content: (
      <div className="flex items-center gap-[6px]">
        <ClockIcon className="w-[13px] h-[13px] text-tasks-scheduled dark:text-tasks-scheduled-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Scheduled
        </h3>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <ClockIcon className="w-[13px] h-[13px] text-tasks-scheduled dark:text-tasks-scheduled-dk" />
        <h3 className="text-md font-medium text-tasks-scheduled dark:text-tasks-scheduled-dk">
          Scheduled
        </h3>
      </div>
    ),
  },
  {
    value: "completed",
    content: (
      <div className="flex items-center gap-[6px]">
        <CompletedIcon className="w-[15px] h-[15px] text-verba-green-success dark:text-verba-green-success-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Completed
        </h3>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <CompletedIcon className="w-[15px] h-[15px] text-verba-green-success dark:text-verba-green-success-dk" />
        <h3 className="text-md font-medium text-verba-green-success dark:text-verba-green-success-dk">
          Completed
        </h3>
      </div>
    ),
  },
  {
    value: "no_show",
    content: (
      <div className="flex items-center gap-[6px]">
        <CrossIcon className="w-4 h-4 text-lead-stage-engaged dark:text-lead-stage-engaged-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          No Show
        </h3>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <CrossIcon className="w-4 h-4 text-lead-stage-engaged dark:text-lead-stage-engaged-dk" />
        <h3 className="text-md font-medium text-lead-stage-engaged dark:text-lead-stage-engaged-dk">
          No Show
        </h3>
      </div>
    ),
  },
  {
    value: "cancelled",
    content: (
      <div className="flex items-center gap-[6px]">
        <CrossIcon className="w-4 h-4 text-verba-red-alert dark:text-verba-red-alert-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Cancelled
        </h3>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <CrossIcon className="w-4 h-4 text-verba-red-alert dark:text-verba-red-alert-dk" />
        <h3 className="text-md font-medium text-verba-red-alert dark:text-verba-red-alert-dk">
          Cancelled
        </h3>
      </div>
    ),
  },
];

export const viewingTimeZone = [
  {
    value: "Asia/Kolkata",
    label: "(GMT+05:30) Asia/Kolkata",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+05:30) Asia/Kolkata
      </span>
    ),
  },
  {
    value: "Asia/Shanghai",
    label: "(GMT+08:00) Asia/Shanghai",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+08:00) Asia/Shanghai
      </span>
    ),
  },
  {
    value: "Australia/Melbourne",
    label: "(GMT+10:00) Australia/Melbourne",
    content: (
      <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        (GMT+10:00) Australia/Melbourne
      </span>
    ),
  },
];

export const meetingPlatformOptions = [
  // {
  //   value: "google-meet",
  //   label: "Google Meet",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <GoogleMeetIcon className="w-[18px] h-[18px] " />
  //       Google Meet
  //     </span>
  //   ),
  // },
  // {
  //   value: "zoom",
  //   label: "Zoom",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <ZoomIcon className="w-[18px] h-[18px] " />
  //       Zoom
  //     </span>
  //   ),
  // },
  {
    value: "teams",
    label: "Microsoft Teams",
    content: (
      <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        <MicrosoftTeamsIcon className="w-[18px] h-[18px] " />
        Microsoft Teams
      </span>
    ),
  },
  {
    value: "other",
    label: "Other",
    content: (
      <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        Other
      </span>
    ),
  },
  // {
  //   value: "facetime",
  //   label: "Facetime",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <FacetimeIcon className="w-[18px] h-[18px] " />
  //       Facetime
  //     </span>
  //   ),
  // },
  // {
  //   value: "skype",
  //   label: "Skype",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <SkypeIcon className="w-[18px] h-[18px] " />
  //       Skype
  //     </span>
  //   ),
  // },
  // {
  //   value: "whatsapp",
  //   label: "Whatsapp Video call",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <WhatsappIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
  //       Whatsapp Video call
  //     </span>
  //   ),
  // },
  // {
  //   value: "cisco-webex",
  //   label: "Cisco Webex",
  //   content: (
  //     <span className="flex gap-2 items-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
  //       <CiscoWebexIcon className="w-[18px] h-[18px]" />
  //       Cisco Webex
  //     </span>
  //   ),
  // },
];

export const STATUS_COLORS = {
  completed: "text-primary-green-dk dark:text-primary-green-dk",
  scheduled: "text-tasks-scheduled dark:text-tasks-scheduled-dk",
  in_progress: "text-primary-orange-dk dark:text-primary-orange-dk",
  overdue: "text-primary-red-dk dark:text-primary-red-dk",
  default: "text-secondary-blue-dk dark:text-primary-gray-lightest",
} as const;

export const LeadStageColors = {
  enquired:
    "bg-[var(--color-lead-stage-enquiries)] dark:bg-[var(--color-lead-stage-enquiries-dk)]",
  engaged:
    "bg-[var(--color-lead-stage-engaged)] dark:bg-[var(--color-lead-stage-engaged-dk)]",
  contacted:
    "bg-[var(--color-lead-stage-contacted)] dark:bg-[var(--color-lead-stage-contacted-dk)]",
  in_progress:
    "bg-[var(--color-lead-stage-in-progress)] dark:bg-[var(--color-lead-stage-in-progress-dk)]",
  qualified:
    "bg-[var(--color-lead-stage-qualified)] dark:bg-[var(--color-lead-stage-qualified-dk)]",
  application:
    "bg-[var(--color-lead-stage-application)] dark:bg-[var(--color-lead-stage-application-dk)]",
  deposit_requested:
    "bg-[var(--color-lead-stage-deposit-requested)] dark:bg-[var(--color-lead-stage-deposit-requested-dk)]",
  deposit:
    "bg-[var(--color-lead-stage-deposit)] dark:bg-[var(--color-lead-stage-deposit-dk)]",
  accepted:
    "bg-[var(--color-lead-stage-accepted)] dark:bg-[var(--color-lead-stage-accepted-dk)]",
  complete:
    "bg-[var(--color-lead-stage-completed)] dark:bg-[var(--color-lead-stage-completed-dk)]",
  lost: "bg-[var(--color-lead-stage-lost)] dark:bg-[var(--color-lead-stage-lost-dk)]",
  default: "bg-heading-text dark:bg-heading-text-dk",
} as const;

export const MODALITY_ICONS = {
  VerbaMessenger: VerbamessengerIcon,
  VerbaMail: VerbamailIcon,
  VerbaChat: VerbachatIcon,
  VerbaCall: VerbacallIcon,
  VerbaSMS: VerbasmsIcon,
  "Facebook Messenger": FbMessengerIcon,
  VerbaWeChat: WeChatIcon,
  "Instagram DMs": InstagramIcon,
} as const;

export const MODALITY_STYLES = {
  VerbaMessenger: "text-verba-messenger dark:text-verba-messenger-dk",
  VerbaMail: "text-verba-mail dark:text-verba-mail-dk",
  VerbaChat: "text-verba-chat dark:text-verba-chat-dk",
  VerbaCall: "text-verba-lavender dark:text-verba-lavender-dk",
  VerbaSMS: "text-verba-sms dark:text-verba-sms-dk",
  "Facebook Messenger":
    "text-verba-fb-messenger dark:text-verba-fb-messenger-dk",
  VerbaWeChat: "text-verba-wechat dark:text-verba-wechat-dk",
  "Instagram DMs": "text-verba-instagram dark:text-verba-instagram-dk",
} as const;

export const CHANNEL_TO_MODALITY = {
  whatsapp: "VerbaMessenger",
  email: "VerbaMail",
  widget: "VerbaChat",
  call: "VerbaCall",
  sms: "VerbaSMS",
  fb_messenger: "Facebook Messenger",
  wechat: "VerbaWeChat",
  instagram: "Instagram DMs",
} as const;

export const VIEWING_ACTION_MENU_WIDTH_PX = 180;
export const VIEWING_ACTION_MENU_GAP_PX = 4;

export const VIEWING_ACTION_MENU_ITEM_CLASS =
  "flex items-center gap-[4px] w-full px-[8px] py-[8px] rounded-[8px] text-left hover:bg-hover-effect dark:hover:bg-hover-effect-dk cursor-pointer";

export const VIEWING_ACTION_MENU_ITEM_LABEL_CLASS =
  "text-md font-normal text-heading-text dark:text-heading-text-dk whitespace-nowrap";

export const VIEWING_ACTION_MENU_DELETE_CLASS =
  "flex items-center gap-[4px] w-full px-[8px] py-[8px] rounded-[8px] text-left hover:bg-tag-red-bg dark:hover:bg-tag-red-bg-dk cursor-pointer";

export const VIEWING_ACTION_MENU_DELETE_LABEL_CLASS =
  "text-md font-normal text-verba-red-alert dark:text-verba-red-alert-dk whitespace-nowrap";

export const TAG_COLORS = {
  "#E9FAEF":
    "bg-verba-green-success/10 dark:bg-verba-green-success-dk/10 border border-verba-green-success/30",
  "#FFF6E6":
    "bg-verba-mail/10 dark:bg-verba-mail-dk/10 border border-verba-mail/30",
  "#FFDEDE":
    "bg-verba-red-alert/10 dark:bg-verba-red-alert-dk/10 border border-verba-red-alert/30",
  default:
    "bg-verba-mail/10 dark:bg-verba-mail-dk/10 border border-verba-mail/30",
} as const;
